import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import styles from './StaffMemberInformationCard.module.scss';
import { getUserInfo } from './_api';
import { useEffect, useState } from 'react';

/**
 * staffMember : StaffMember
 * actions : React.Node[]: renders each component as card actions.
 */
const StaffMemberInformationCard = ({ staffMember, actions }) => {
	const [userInfo, setUserInfo] = useState({ ...staffMember });

	useEffect(() => {
		if (staffMember.fiId) {
			getUserInfo(staffMember?.fiId).then(response => {
				setUserInfo(response.data.payload);
			});
		}
	}, [staffMember.fiId]);

	return (
		<Card raised={false}>
			<CardContent>
				{staffMember?.delegatedReviewerMessage && (
					<Alert severity='info'>
						{staffMember?.delegatedReviewerMessage}
					</Alert>
				)}
				{userInfo?.firstName && userInfo?.lastName && (
					<div className={styles.display_flex}>
						<Typography sx={{ color: 'black', marginRight: '1em' }}>
							Name:
						</Typography>
						<Typography
							variant='body2'
							sx={{ color: 'text.secondary' }}
						>
							{userInfo?.firstName + ' ' + userInfo?.lastName}
						</Typography>
					</div>
				)}
				{userInfo?.employeeId && (
					<div className={styles.display_flex}>
						<Typography sx={{ color: 'black', marginRight: '1em' }}>
							Employee ID:
						</Typography>
						<Typography
							variant='body2'
							sx={{ color: 'text.secondary' }}
						>
							{userInfo?.employeeId}
						</Typography>
					</div>
				)}
				<div className={styles.display_flex}>
					<Typography sx={{ color: 'black', marginRight: '1em' }}>
						Email:
					</Typography>
					<Typography
						variant='body2'
						sx={{ color: 'text.secondary' }}
					>
						{userInfo?.email?.length > 0 ? userInfo?.email : 'N/A'}
					</Typography>
				</div>
				<div className={styles.display_flex}>
					<Typography sx={{ color: 'black', marginRight: '1em' }}>
						Network ID (NTID):
					</Typography>
					<Typography
						variant='body2'
						sx={{ color: 'text.secondary' }}
					>
						{userInfo?.ntid ? userInfo?.ntid : 'N/A'}
					</Typography>
				</div>
				<div className={styles.display_flex}>
					<Typography sx={{ color: 'black', marginRight: '1em' }}>
						Date Last Validated:
					</Typography>
					<Typography
						variant='body2'
						sx={{ color: 'text.secondary' }}
					>
						{userInfo?.dateValidated
							? new Date(
									userInfo?.dateValidated,
								).toLocaleDateString('en-US')
							: 'N/A'}
					</Typography>
				</div>
				<div className={styles.display_flex}>
					<Typography sx={{ color: 'black', marginRight: '1em' }}>
						Validation Due:
					</Typography>
					<Typography
						variant='body2'
						sx={{ color: 'text.secondary' }}
					>
						{userInfo?.dateValidationDue
							? new Date(
									userInfo?.dateValidationDue,
								).toLocaleDateString('en-US')
							: 'N/A'}
					</Typography>
					{userInfo?.isExpired ? (
						<Typography sx={{ color: 'red', marginLeft: '1em' }}>
							(Expired)
						</Typography>
					) : null}
				</div>
				{userInfo?.nonEmployeeCompanyName ? (
					<div className={styles.display_flex}>
						<Typography sx={{ color: 'black', marginRight: '1em' }}>
							Company Name:
						</Typography>
						<Typography
							variant='body2'
							sx={{ color: 'text.secondary' }}
						>
							{userInfo?.nonEmployeeCompanyName}
						</Typography>
					</div>
				) : null}
			</CardContent>
			<CardActions>{actions}</CardActions>
		</Card>
	);
};

export default StaffMemberInformationCard;
